import { LimiterWarning } from './LimiterWarning';
import { MyPosition } from './MyPosition';
import { UnstakeInput } from './UnstakeInput';
import { TextUnstakeFees } from './TextUnstakeFees';
import { Stats } from './Stats';

export const LST = {
  LimiterWarning,
  MyPosition,
  UnstakeInput,
  TextUnstakeFees,
  Stats,
};